/** Shared copy for tenant ID verification and bank statements (signup + profile). */

/** Shown under Id Verification (types are chosen via radios). */
export const TENANT_DOC_FILE_LIMIT_SUBLINE = 'Up to 4 files (image or PDF)';

export const MAX_DOCUMENT_FILES_PER_CATEGORY = 4;

export const TENANT_DOC_ACCEPT_ATTR =
  '.pdf,application/pdf,image/jpeg,image/png,image/webp,image/gif';

export const MULTI_FILE_HINT_TEXT = ' · Up to 4 files (image or PDF)';

/** API values for /auth/upload-tenant-documents/v2 — sent as `documents[i][type]` for ID rows. */
export const ID_VERIFICATION_TYPE_OPTIONS = [
  { value: 'PASSPORT', label: 'Passport' },
  { value: 'DRIVING_LICENSE', label: 'Driving License' },
  { value: 'NATIONAL_INSURANCE_NUMBER', label: 'National Insurance Number' },
  { value: 'SOCIAL_SECURITY_NUMBER', label: 'Social Security Number' },
  { value: 'TAX_ID_NUMBER', label: 'Tax ID Number' },
  { value: 'NATIONAL_ID_CARD', label: 'National ID Card' },
  { value: 'VISA', label: 'Visa' },
  { value: 'POLLING_CARD', label: 'Polling Card' },
  { value: 'RESIDENCE_PERMIT', label: 'Residence Permit' },
];

export function isValidTenantDocFile(file) {
  const validTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/webp', 'image/gif'];
  const validExt = ['.pdf', '.jpg', '.jpeg', '.png', '.webp', '.gif'];
  const name = (file.name || '').toLowerCase();
  return validTypes.includes(file.type) || validExt.some((ext) => name.endsWith(ext));
}
